module.exports = "/_next/static/images/1e95f8efd06d770db12c291239552846-vigilado.png.webp";